if (!customElements.get('product-cross-sells')) {
  class ProductCrossSells extends HTMLElement {
  constructor() {
    super();
    this.updateTotals = this.updateTotals.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  connectedCallback() {
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
    this.selects = this.querySelectorAll('select[name="variant-id"]');
    this.btnAtc = this.querySelector('.btn-atc');

    this.checkboxes.forEach(cb => cb.addEventListener('change', this.updateTotals));
    this.selects.forEach(sel => sel.addEventListener('change', this.updateTotals));
    
    if (this.btnAtc) {
      this.btnAtc.addEventListener('click', this.addToCart);
    }
    
    this.formatMoney = window.Shopify && window.Shopify.formatMoney 
      ? window.Shopify.formatMoney 
      : function(cents, format) {
          if (typeof cents == 'string') { cents = cents.replace('.', ''); }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || '${{amount}}');

          function defaultOption(opt, def) {
             return (typeof opt == 'undefined' ? def : opt);
          }

          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }
            number = (number / 100.0).toFixed(precision);
            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents;
          }

          switch(formatString.match(placeholderRegex)[1]) {
            case 'amount': value = formatWithDelimiters(cents, 2); break;
            case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
            case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          }
          return formatString.replace(placeholderRegex, value);
        };

    this.updateTotals();
  }

  updateTotals() {
    let format = '₹{{amount}}';
    if (window.MinimogSettings && window.MinimogSettings.money_format) {
      format = window.MinimogSettings.money_format;
    } else if (window.theme && window.theme.moneyFormat) {
      format = window.theme.moneyFormat;
    }

    if (format.includes('amount') && !format.includes('{{')) {
       format = '₹{{amount}}';
    }

    this.selects.forEach(sel => {
      const card = sel.closest('.product-card') || sel.closest('.product-block-cross-sells-list-item');
      if (card) {
        const cardPriceEl = card.querySelector('[data-card-price]');
        if (cardPriceEl) {
           const opt = sel.options[sel.selectedIndex];
           const price = parseInt(opt.getAttribute('data-price') || 0);
           let fPrice = this.formatMoney(price, format);
           fPrice = fPrice.replace('.00', '');
           cardPriceEl.innerHTML = fPrice;
        }
      }
    });

    let totalPrice = 0;
    let totalCompare = 0;
    let anySelected = false;

    this.checkboxes.forEach(cb => {
      const card = cb.closest('.product-card') || cb.closest('.product-block-cross-sells-list-item') || cb.closest('.cross-sells-item');
      if (card) {
        card.setAttribute('data-is-selected', cb.checked ? 'true' : 'false');
      }

      if (cb.checked) {
        anySelected = true;
        if (card) {
          const select = card.querySelector('select[name="variant-id"]');
          const hiddenInput = card.querySelector('input[type="hidden"][name="variant-id"]');
          
          if (select) {
            const selectedOption = select.options[select.selectedIndex];
            totalPrice += parseInt(selectedOption.getAttribute('data-price') || 0);
            const comp = parseInt(selectedOption.getAttribute('data-compare-at-price') || 0);
            totalCompare += comp > 0 ? comp : parseInt(selectedOption.getAttribute('data-price') || 0);
          } else if (hiddenInput) {
            totalPrice += parseInt(hiddenInput.getAttribute('data-price') || 0);
            const comp = parseInt(hiddenInput.getAttribute('data-compare-at-price') || 0);
            totalCompare += comp > 0 ? comp : parseInt(hiddenInput.getAttribute('data-price') || 0);
          }
        }
      }
    });

    const elTotalPrice = this.querySelector('[data-total-price]');
    const elTotalCompare = this.querySelector('[data-total-compare-price]');
    const elTotalSavings = this.querySelector('[data-total-savings]');

    if (elTotalPrice) {
      let fPrice = this.formatMoney(totalPrice, format);
      fPrice = fPrice.replace('.00', '');
      elTotalPrice.innerHTML = fPrice;
    }
    
    if (elTotalCompare) {
      let fComp = this.formatMoney(totalCompare, format);
      fComp = fComp.replace('.00', '');
      elTotalCompare.innerHTML = fComp;
      const sTag = elTotalCompare.closest('s');
      if (sTag) {
        if (totalCompare > totalPrice) {
          sTag.removeAttribute('hidden');
        } else {
          sTag.setAttribute('hidden', '');
        }
      }
    }
    
    const totalContainer = this.querySelector('.zu-cs-total-container');
    if (totalContainer) {
      if (anySelected) {
        totalContainer.style.display = '';
      } else {
        totalContainer.style.display = 'none';
      }
    }

    if (elTotalSavings) {
      const savingsP = elTotalSavings.closest('.cross-sells-footer-total-savings');
      if (totalCompare > totalPrice) {
        let fSav = this.formatMoney(totalCompare - totalPrice, format);
        fSav = fSav.replace('.00', '');
        elTotalSavings.innerHTML = fSav;
        if (savingsP) savingsP.removeAttribute('hidden');
      } else {
        if (savingsP) savingsP.setAttribute('hidden', '');
      }
    }

    if (this.btnAtc) {
      if (anySelected) {
        this.btnAtc.removeAttribute('disabled');
      } else {
        this.btnAtc.setAttribute('disabled', 'disabled');
      }
    }
  }

  async addToCart() {
    if (!this.btnAtc) return;
    this.btnAtc.classList.add('loading');
    this.btnAtc.setAttribute('disabled', 'disabled');
    
    const items = [];
    this.checkboxes.forEach(cb => {
      if (cb.checked) {
        const card = cb.closest('.product-card') || cb.closest('.product-block-cross-sells-list-item');
        if (card) {
          const select = card.querySelector('select[name="variant-id"]');
          const hiddenInput = card.querySelector('input[type="hidden"][name="variant-id"]');
          if (select) {
            items.push({ id: parseInt(select.value), quantity: 1 });
          } else if (hiddenInput) {
            items.push({ id: parseInt(hiddenInput.value), quantity: 1 });
          }
        }
      }
    });

    if (items.length === 0) {
      this.btnAtc.classList.remove('loading');
      return;
    }

    try {
      const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(routesRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      
      const res = await response.json();
      this.btnAtc.classList.remove('loading');
      this.btnAtc.removeAttribute('disabled');
      
      if (window.MinimogEvents) {
        window.MinimogEvents.emit('cart:refresh');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      
      const cartDrawer = document.querySelector('m-cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.onCartDrawerUpdate === 'function') {
          cartDrawer.onCartDrawerUpdate();
        }
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

    } catch (err) {
      console.error(err);
      this.btnAtc.classList.remove('loading');
      this.btnAtc.removeAttribute('disabled');
    }
  }
  }

  customElements.define('product-cross-sells', ProductCrossSells);
}
